import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DeviceTable from "components/device/single/CustomerSideTable";

export let setTimeline = () => {};
export let timeline = {};

export let setSingleDevice = () => {};
export let singleDevice = {};


const SingleDevice = ({ sidebarTheme, layoutTheme }) => {

    [timeline, setTimeline] = useState(new Date());
    [singleDevice, setSingleDevice] = useState({});
    const [deviceAttr, setDeviceAttr] = useState(
        {
            "_id": '',
            "deviceModel": '',
            "name": '',
            "identity": '',
            "deviceCompany": '',
            "publishName": '',
            "subscribeName": '',
            "sampleName": '',
            "deviceData": []
        }
    );

    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal
        
        if(singleDevice._id) {
            fetch(`/api/devices/singledevicewithattr?id=${encodeURIComponent(singleDevice._id)}&time=${encodeURIComponent(timeline)}`, {signal: signal})
            .then(res => res.json())
            .then(_device => setDeviceAttr(_device))
            .catch(e => {
                throw e
            })
        }

        return function cleanup() {
            abortController.abort()
        }
    },[timeline, singleDevice]);

    return (

    <div>
        <DeviceTable device={deviceAttr}/>
    </div>
    
  );
};
const mapStateToProps = state => {
    return {
        ...state.themeChanger
    };
};

export default connect(
    mapStateToProps,
    null
)(SingleDevice);
